import "../Style/Uiuxstack.css";

import figmaImg from "../assets/figma.png";
import adobeImg from "../assets/adobe.png";
import psImg from "../assets/ps.png";
import aiImg from "../assets/ai.png";
import xdImg from "../assets/xd.png";
import sketchImg from "../assets/sketch.png";
import miroImg from "../assets/miro.png";
import framerImg from "../assets/framer.png";

const tools = [
  { src: sketchImg, alt: "Sketch" },
  { src: miroImg, alt: "Miro" },
  { src: framerImg, alt: "Framer" },
  { src: figmaImg, alt: "Figma" },
  { src: xdImg, alt: "Adobe XD" },
  { src: psImg, alt: "Photoshop" },
  { src: aiImg, alt: "Illustrator" },
  { src: adobeImg, alt: "Adobe" },
];

export default function UiuxStack() {
  const items = [...tools, ...tools];

  return (
    <section className="uiux-stack-section">
      <div className="uiux-stack-pattern" aria-hidden="true" />

      <div className="uiux-stack-inner">
        <div className="uiux-stack-badge">
          <div className="uiux-stack-badge-ring" aria-hidden="true" />
          <h2 className="uiux-stack-badge-title">Technology Stack</h2>
          <span className="uiux-stack-badge-subtitle">
            Design &amp; Prototyping Tools
          </span>
        </div>

        <div className="uiux-stack-right">
          <span className="uiux-stack-eyebrow">Tools &amp; Technology</span>

          <h3 className="uiux-stack-info-heading">
            Industry-Leading Design Tools &amp; Technologies
          </h3>

          <p className="uiux-stack-info-desc">
            At MPeoples, we leverage the latest UI/UX design tools and
            collaborative workflows to create intuitive, scalable, and
            visually compelling digital experiences. Our expert designers use
            industry-standard software for user research, wireframing,
            prototyping, interface design, design systems, and seamless
            developer handoff, ensuring faster delivery and exceptional
            product quality.
          </p>

          <div className="uiux-stack-marquee-card">
            <div className="uiux-stack-marquee-outer">
              <div className="uiux-stack-marquee-track">
                {items.map((tool, i) => (
                  <div className="uiux-stack-cell" key={i}>
                    <div className="uiux-stack-icon-wrap">
                      <img
                        src={tool.src}
                        alt={tool.alt}
                        className="uiux-stack-icon"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}